@if (visible()) {
  <div class="note-collaboration-controls">
    @if (draft() || loadState() === 'ready') {
      @if (showAccessControl()) {
        <app-button2
          #accessTrigger
          class="note-access-trigger"
          appearance="secondary"
          size="m"
          rounding="lg"
          [ariaLabel]="draft() ? 'Note access' : teamName() + ' team access'"
          [attr.title]="draft() ? (currentAccess() === 'editor' ? 'Editor' : 'Read only') : teamName()"
          stchPopover
          stchPopoverTrigger="click"
          [stchPopoverTemplate]="accessPanel"
          stchPopoverPlacement="bottomLeft"
          [stchPopoverOffsetY]="2"
          [stchPopoverNoBorder]="true"
          [stchPopoverCloseOnOutsideClick]="true"
          [ariaExpanded]="accessOpen()"
          ariaHaspopup="dialog"
          [stchPopoverShowUntil]="closeAccess"
          (stchPopoverVisibleChange)="accessOpen.set($event)"
        >
          @if (draft()) {
            <span class="note-team-name">{{ currentAccess() === 'editor' ? 'Editor' : 'Read only' }}</span>
          } @else {
            <span class="note-team-avatar">{{ teamInitials() }}</span>
            <span class="note-team-name">{{ teamName() }}</span>
          }
          <app-icon class="note-team-chevron" name="sapphire-chevron-down" size="s" />
        </app-button2>
        <ng-template #accessPanel>
          <div role="dialog" aria-label="Note access">
            <app-note-access-panel
              [view]="accessView()"
              [teamName]="teamName()"
              (accessChange)="changeAccess($event)"
              (retry)="retry()"
              (close)="closeAccessPanel()"
            />
          </div>
        </ng-template>
      }

      @if (showAssigneeControl()) {
        <app-assign-to-button
          workspaceKind="team"
          itemLabel="note"
          searchMode="external"
          [members]="members()"
          [selectedMembers]="selectedMembers()"
          [currentUserId]="accountUid()"
          [assigneeIds]="selectedIds()"
          [capabilities]="capabilities()"
          [allowReadOnlyEmpty]="!draft()"
          [emptyLabel]="assignLabel()"
          [status]="draft() ? 'draft' : (collaboration()?.status ?? 'open')"
          [pending]="pending() || (draft() && draftLocked())"
          [loading]="loading()"
          [hasMore]="hasMore()"
          [loadingMore]="loadingMore()"
          [errorText]="errorText()"
          (searchChange)="searchMembers($event)"
          (loadMore)="loadMoreMembers()"
          (assigneeIdsChange)="selectAssignees($event)"
          (resolve)="setResolved(true)"
          (reopen)="setResolved(false)"
          (retry)="retry()"
        />
      }
    } @else {
      @if (showAccessControl()) {
        <span class="note-team-identity" [title]="teamName()">
          <span class="note-team-avatar">{{ teamInitials() }}</span>
          <span class="note-team-name">{{ teamName() }}</span>
        </span>
      }
      @if (showAssigneeControl()) {
        <span class="note-assignment-unavailable" [title]="unavailableReason()">
          <app-button2
            appearance="secondary"
            size="m"
            [height]="32"
            [disabled]="true"
            [ariaLabel]="unavailableReason()"
          >
            <app-icon name="sapphire-user-plus" size="m" />
            {{ assignLabel() }}
            <app-icon name="sapphire-chevron-down" size="s" />
          </app-button2>
        </span>
      }
      @if (loadState() === 'error') {
        <app-button2
          appearance="secondary-text"
          size="s"
          ariaLabel="Retry loading assignment details"
          (click)="retry()"
        >
          Retry
        </app-button2>
        <span class="sr-only" role="alert">Could not load assignment details.</span>
      }
    }
  </div>
}
